(function () {
  const COLOR_MAP = {
    black: '#111111',
    schwarz: '#111111',
    blue: '#1766d3',
    blau: '#1766d3',
    blue_dark: '#143c8d',
    dunkelblau: '#143c8d',
    blue_middle: '#2475f0',
    mittelblau: '#2475f0',
    blue_navy: '#173561',
    navy: '#173561',
    marineblau: '#173561',
    red: '#ff4026',
    rot: '#ff4026',
    gray: '#909090',
    grey: '#909090',
    grau: '#909090',
    silver: '#b8bcc4',
    silber: '#b8bcc4',
    silber_grau: '#b8bcc4',
    silver_grey: '#b8bcc4',
    white: '#f2f2f2',
    weiss: '#f2f2f2',
    transparent: 'linear-gradient(135deg, #fafafa 0%, #d2d2d2 50%, #fafafa 100%)'
  };

  const COPY = {
    de: {
      unavailableComparison: 'Der Produktvergleich ist derzeit nicht verfügbar.',
      maximum: 'Sie können innerhalb einer Kategorie maximal {count} Produkte gleichzeitig vergleichen.',
      product: 'Produkt',
      products: 'Produkte',
      removeAria: '{product} aus dem Vergleich entfernen',
      chooseProducts: 'Wählen Sie Produkte aus, um den Direktvergleich zu füllen.',
      directComparison: 'im Direktvergleich',
      selected: '{count} {products} ausgewählt. Innerhalb dieser Kategorie lassen sich bis zu {maximum} Produkte parallel gegenüberstellen.',
      reset: 'Auswahl zurücksetzen',
      colors: 'Farben',
      profile: 'Profil',
      coating: 'Beschichtung',
      idealFor: 'Ideal für',
      sizes: 'Gebinde',
      availability: 'Verfügbarkeit',
      available: 'Sofort verfügbar',
      unavailable: 'Derzeit nicht verfügbar',
      strengths: 'Stärken',
      remove: 'Aus Vergleich entfernen',
      add: 'Zum Vergleich hinzufügen',
      open: 'Produkt öffnen',
      seeProductPage: 'Siehe Produktseite',
      chooseAtLeastOne: 'Wählen Sie mindestens ein Produkt aus, um die Vergleichswerte anzuzeigen.',
      feature: 'Merkmal',
      from: 'Ab',
      fromLower: 'ab',
      tds: 'Technisches Datenblatt',
      sds: 'Sicherheitsdatenblatt',
      rows: {
        profile: 'Produktprofil', ideal_for: 'Ideal für', application: 'Anwendungsbereich',
        materials: 'Geeignete Rümpfe', waters: 'Reviere', speed: 'Höchstgeschwindigkeit',
        system: 'System / Oberfläche', coverage: 'Ergiebigkeit', coats: 'Empfohlener Aufbau',
        availability: 'Verfügbarkeit', sizes: 'Verfügbare Gebinde', colors: 'Farben',
        environment: 'Umweltprofil', strengths: 'Besondere Stärken', notes: 'Wichtige Hinweise',
        documents: 'Datenblätter'
      }
    },
    en: {
      unavailableComparison: 'Product comparison is currently unavailable.',
      maximum: 'You can compare up to {count} products within one category.',
      product: 'product',
      products: 'products',
      removeAria: 'Remove {product} from the comparison',
      chooseProducts: 'Select products to start the side-by-side comparison.',
      directComparison: 'side by side',
      selected: '{count} {products} selected. You can compare up to {maximum} products within this category.',
      reset: 'Clear selection',
      colors: 'Colours',
      profile: 'Profile',
      coating: 'Coating',
      idealFor: 'Best for',
      sizes: 'Pack sizes',
      availability: 'Availability',
      available: 'Available',
      unavailable: 'Currently unavailable',
      strengths: 'Strengths',
      remove: 'Remove from comparison',
      add: 'Add to comparison',
      open: 'View product',
      seeProductPage: 'See product page',
      chooseAtLeastOne: 'Select at least one product to view the comparison values.',
      feature: 'Feature',
      from: 'From',
      fromLower: 'from',
      tds: 'Technical data sheet',
      sds: 'Safety data sheet',
      rows: {
        profile: 'Product profile', ideal_for: 'Best for', application: 'Application',
        materials: 'Suitable hulls', waters: 'Water types', speed: 'Maximum speed',
        system: 'System / finish', coverage: 'Coverage', coats: 'Recommended system',
        availability: 'Availability', sizes: 'Available pack sizes', colors: 'Colours',
        environment: 'Environmental profile', strengths: 'Key strengths', notes: 'Important notes',
        documents: 'Data sheets'
      }
    }
  };

  class AntifoulingComparison extends HTMLElement {
    connectedCallback() {
      if (this.initialized) {
        return;
      }

      this.initialized = true;
      this.selectedByCategory = {};
      this.noticeTimer = null;
      this.handleClick = this.handleClick.bind(this);

      this.data = this.readData();
      this.categories = Array.isArray(this.data.categories) ? this.data.categories.filter((category) => Array.isArray(category.products) && category.products.length) : [];
      this.maxCompare = Math.max(2, Math.min(Number(this.data.maxCompare) || 4, 4));
      this.defaultAutoSelect = Math.max(0, Math.min(Number(this.data.defaultAutoSelect) || 0, this.maxCompare));
      this.locale = this.data.locale || 'de-DE';
      this.currency = this.data.currency || 'EUR';
      this.copy = String(this.locale).toLowerCase().startsWith('en') ? COPY.en : COPY.de;

      this.noticeElement = this.querySelector('[data-notice]');
      this.tabsElement = this.querySelector('[data-tabs]');
      this.summaryElement = this.querySelector('[data-summary]');
      this.cardsElement = this.querySelector('[data-cards]');
      this.tableElement = this.querySelector('[data-table]');

      this.addEventListener('click', this.handleClick);

      if (!this.categories.length) {
        this.renderUnavailable();
        return;
      }

      this.activeCategoryKey = this.categories[0].key;
      this.ensureSelectionState();
      this.render();
    }

    readData() {
      const script = this.querySelector('[data-comparison-data]');

      if (!script) {
        return {};
      }

      try {
        return JSON.parse(script.textContent);
      } catch (error) {
        console.error('Antifouling comparison data could not be parsed.', error);
        return {};
      }
    }

    handleClick(event) {
      const actionElement = event.target.closest('[data-action]');

      if (!actionElement || !this.contains(actionElement)) {
        return;
      }

      const { action } = actionElement.dataset;

      if (action === 'change-category') {
        const nextKey = actionElement.dataset.categoryKey;

        if (nextKey && nextKey !== this.activeCategoryKey) {
          this.activeCategoryKey = nextKey;
          this.ensureSelectionState();
          this.render();
        }
      }

      if (action === 'toggle-product') {
        const productId = actionElement.dataset.productId;

        if (productId) {
          this.toggleProduct(productId);
        }
      }

      if (action === 'remove-product') {
        const productId = actionElement.dataset.productId;

        if (productId) {
          this.setSelectedIds(this.getSelectedIds().filter((id) => id !== productId));
          this.render();
        }
      }

      if (action === 'clear-category') {
        this.setSelectedIds([]);
        this.render();
      }
    }

    ensureSelectionState() {
      const activeCategory = this.getActiveCategory();

      if (!activeCategory) {
        return;
      }

      const validIds = new Set(activeCategory.products.map((product) => String(product.id)));

      if (!Object.prototype.hasOwnProperty.call(this.selectedByCategory, this.activeCategoryKey)) {
        const initialSelection = activeCategory.products
          .slice(0, this.defaultAutoSelect)
          .map((product) => String(product.id));

        this.selectedByCategory[this.activeCategoryKey] = initialSelection;
      } else {
        this.selectedByCategory[this.activeCategoryKey] = this.selectedByCategory[this.activeCategoryKey]
          .map((id) => String(id))
          .filter((id) => validIds.has(id))
          .slice(0, this.maxCompare);
      }
    }

    getActiveCategory() {
      return this.categories.find((category) => category.key === this.activeCategoryKey) || null;
    }

    getSelectedIds() {
      return Array.isArray(this.selectedByCategory[this.activeCategoryKey]) ? this.selectedByCategory[this.activeCategoryKey] : [];
    }

    setSelectedIds(ids) {
      this.selectedByCategory[this.activeCategoryKey] = ids.slice(0, this.maxCompare);
    }

    getSelectedProducts() {
      const activeCategory = this.getActiveCategory();

      if (!activeCategory) {
        return [];
      }

      const selectedIds = new Set(this.getSelectedIds());

      return activeCategory.products.filter((product) => selectedIds.has(String(product.id)));
    }

    toggleProduct(productId) {
      const normalizedId = String(productId);
      const currentIds = this.getSelectedIds();

      if (currentIds.includes(normalizedId)) {
        this.setSelectedIds(currentIds.filter((id) => id !== normalizedId));
        this.render();
        return;
      }

      if (currentIds.length >= this.maxCompare) {
        this.showNotice(this.interpolate(this.copy.maximum, { count: this.maxCompare }));
        return;
      }

      this.setSelectedIds(currentIds.concat(normalizedId));
      this.render();
    }

    render() {
      this.renderTabs();
      this.renderSummary();
      this.renderCards();
      this.renderTable();
    }

    renderUnavailable() {
      const message = `<div class="antifouling-compare__table-empty">${this.escapeHtml(this.copy.unavailableComparison)}</div>`;

      if (this.tabsElement) {
        this.tabsElement.innerHTML = '';
      }

      if (this.summaryElement) {
        this.summaryElement.innerHTML = message;
      }

      if (this.cardsElement) {
        this.cardsElement.innerHTML = '';
      }

      if (this.tableElement) {
        this.tableElement.innerHTML = '';
      }
    }

    renderTabs() {
      if (!this.tabsElement) {
        return;
      }

      this.tabsElement.innerHTML = this.categories
        .map((category) => {
          const isActive = category.key === this.activeCategoryKey;

          return `
            <button
              class="antifouling-compare__tab${isActive ? ' is-active' : ''}"
              type="button"
              data-action="change-category"
              data-category-key="${this.escapeAttribute(category.key)}"
              aria-pressed="${isActive ? 'true' : 'false'}"
            >
              ${this.escapeHtml(category.label)}
            </button>
          `;
        })
        .join('');
    }

    renderSummary() {
      if (!this.summaryElement) {
        return;
      }

      const activeCategory = this.getActiveCategory();

      if (!activeCategory) {
        this.summaryElement.innerHTML = '';
        return;
      }

      const selectedProducts = this.getSelectedProducts();
      const countLabel = selectedProducts.length === 1 ? this.copy.product : this.copy.products;
      const chipsHtml = selectedProducts.length
        ? `
          <div class="antifouling-compare__chip-list">
            ${selectedProducts
              .map(
                (product) => `
                  <div class="antifouling-compare__chip">
                    <span>${this.escapeHtml(product.title)}</span>
                    <button type="button" data-action="remove-product" data-product-id="${this.escapeAttribute(String(product.id))}" aria-label="${this.escapeAttribute(this.interpolate(this.copy.removeAria, { product: product.title }))}">×</button>
                  </div>
                `
              )
              .join('')}
          </div>
        `
        : `<div class="antifouling-compare__summary-copy">${this.escapeHtml(this.copy.chooseProducts)}</div>`;

      const selectedCopy = this.interpolate(this.copy.selected, {
        count: selectedProducts.length,
        products: countLabel,
        maximum: this.maxCompare
      });

      this.summaryElement.innerHTML = `
        <div class="antifouling-compare__summary-top">
          <div class="antifouling-compare__summary-copy-wrap">
            <p class="antifouling-compare__summary-title">${this.escapeHtml(activeCategory.label)} ${this.escapeHtml(this.copy.directComparison)}</p>
            <p class="antifouling-compare__summary-copy">${this.escapeHtml(selectedCopy)}</p>
          </div>
          <div class="antifouling-compare__summary-actions">
            <button class="antifouling-compare__ghost-button" type="button" data-action="clear-category">${this.escapeHtml(this.copy.reset)}</button>
          </div>
        </div>
        ${chipsHtml}
      `;
    }

    renderCards() {
      if (!this.cardsElement) {
        return;
      }

      const activeCategory = this.getActiveCategory();

      if (!activeCategory) {
        this.cardsElement.innerHTML = '';
        return;
      }

      const selectedIds = new Set(this.getSelectedIds());

      this.cardsElement.innerHTML = activeCategory.products
        .map((product) => this.renderCard(product, selectedIds.has(String(product.id))))
        .join('');
    }

    renderCard(product, isSelected) {
      const highlights = this.getHighlights(product).slice(0, 3);
      const profile = product.compare && product.compare.profile ? product.compare.profile : product.category_label;
      const idealFor = product.compare && product.compare.ideal_for ? product.compare.ideal_for : '';
      const sizesValue = this.getSizeValue(product);
      const sizesText = Array.isArray(sizesValue) ? (sizesValue.join(', ') || this.copy.seeProductPage) : (sizesValue || this.copy.seeProductPage);
      const unitPriceText = this.getUnitPriceText(product);
      const colorItems = this.getColorItems(product);
      const colorLabels = this.getColorLabels(product);
      const colorsHtml = colorItems.length
        ? `
          <div class="antifouling-compare__meta-item">
            <span class="antifouling-compare__meta-label">${this.escapeHtml(this.copy.colors)}</span>
            <div class="antifouling-compare__swatches">${colorItems.map((color) => this.renderSwatch(color)).join('')}</div>
            <span class="antifouling-compare__meta-value">${this.escapeHtml(colorLabels.join(', '))}</span>
          </div>
        `
        : '';

      return `
        <article class="antifouling-compare__card${isSelected ? ' is-selected' : ''}">
          <div class="antifouling-compare__card-media">
            ${product.featured_image ? `<img src="${this.escapeAttribute(product.featured_image)}" alt="${this.escapeAttribute(product.title)}" loading="lazy">` : ''}
          </div>
          <div class="antifouling-compare__card-header">
            <p class="antifouling-compare__eyebrow">${this.escapeHtml(product.category_label || '')}</p>
            <h3 class="antifouling-compare__card-title">${this.escapeHtml(product.title)}</h3>
            <div class="antifouling-compare__card-price">
              <span class="antifouling-compare__price-main">${this.escapeHtml(product.price_varies ? `${this.copy.from} ${product.price_from}` : product.price_from)}</span>
              ${unitPriceText ? `<span class="antifouling-compare__price-sub">${this.escapeHtml(unitPriceText)}</span>` : ''}
            </div>
          </div>
          <div class="antifouling-compare__meta">
            <div class="antifouling-compare__meta-item">
              <span class="antifouling-compare__meta-label">${this.escapeHtml(this.copy.profile)}</span>
              <span class="antifouling-compare__meta-value">${this.escapeHtml(profile || this.copy.coating)}</span>
            </div>
            ${idealFor ? `
              <div class="antifouling-compare__meta-item">
                <span class="antifouling-compare__meta-label">${this.escapeHtml(this.copy.idealFor)}</span>
                <span class="antifouling-compare__meta-value">${this.escapeHtml(idealFor)}</span>
              </div>
            ` : ''}
            <div class="antifouling-compare__meta-item">
              <span class="antifouling-compare__meta-label">${this.escapeHtml(this.copy.sizes)}</span>
              <span class="antifouling-compare__meta-value">${this.escapeHtml(sizesText)}</span>
            </div>
            <div class="antifouling-compare__meta-item">
              <span class="antifouling-compare__meta-label">${this.escapeHtml(this.copy.availability)}</span>
              <span class="antifouling-compare__meta-value">${this.escapeHtml(product.available ? this.copy.available : this.copy.unavailable)}</span>
            </div>
            ${colorsHtml}
          </div>
          <div class="antifouling-compare__highlights">
            <span class="antifouling-compare__meta-label">${this.escapeHtml(this.copy.strengths)}</span>
            ${this.renderHighlights(highlights)}
          </div>
          <div class="antifouling-compare__actions">
            <button class="antifouling-compare__button${isSelected ? ' is-secondary' : ''}" type="button" data-action="toggle-product" data-product-id="${this.escapeAttribute(String(product.id))}" aria-pressed="${isSelected ? 'true' : 'false'}">
              ${this.escapeHtml(isSelected ? this.copy.remove : this.copy.add)}
            </button>
            <a class="antifouling-compare__product-link" href="${this.escapeAttribute(product.url)}">${this.escapeHtml(this.copy.open)}</a>
          </div>
        </article>
      `;
    }

    renderTable() {
      if (!this.tableElement) {
        return;
      }

      const selectedProducts = this.getSelectedProducts();

      if (!selectedProducts.length) {
        this.tableElement.innerHTML = `<div class="antifouling-compare__table-empty">${this.escapeHtml(this.copy.chooseAtLeastOne)}</div>`;
        return;
      }

      const rowDefinitions = [
        { key: 'profile', label: this.copy.rows.profile, always: true },
        { key: 'ideal_for', label: this.copy.rows.ideal_for },
        { key: 'application', label: this.copy.rows.application },
        { key: 'materials', label: this.copy.rows.materials },
        { key: 'waters', label: this.copy.rows.waters },
        { key: 'speed', label: this.copy.rows.speed },
        { key: 'system', label: this.copy.rows.system },
        { key: 'coverage', label: this.copy.rows.coverage },
        { key: 'coats', label: this.copy.rows.coats },
        { key: 'availability', label: this.copy.rows.availability },
        { key: 'sizes', label: this.copy.rows.sizes },
        { key: 'colors', label: this.copy.rows.colors },
        { key: 'environment', label: this.copy.rows.environment },
        { key: 'strengths', label: this.copy.rows.strengths },
        { key: 'notes', label: this.copy.rows.notes },
        { key: 'documents', label: this.copy.rows.documents }
      ];

      const visibleRows = rowDefinitions.filter((row) => {
        if (row.always) {
          return true;
        }

        return selectedProducts.some((product) => this.valueHasContent(this.getRowValue(row.key, product)));
      });

      this.tableElement.innerHTML = `
        <div class="antifouling-compare__table-scroll">
          <table class="antifouling-compare__table-element">
            <thead>
              <tr>
                <th class="antifouling-compare__row-label">${this.escapeHtml(this.copy.feature)}</th>
                ${selectedProducts.map((product) => `<th>${this.renderTableHeaderProduct(product)}</th>`).join('')}
              </tr>
            </thead>
            <tbody>
              ${visibleRows
                .map(
                  (row) => `
                    <tr>
                      <th class="antifouling-compare__row-label" scope="row">${this.escapeHtml(row.label)}</th>
                      ${selectedProducts.map((product) => `<td>${this.renderRowValue(row.key, this.getRowValue(row.key, product))}</td>`).join('')}
                    </tr>
                  `
                )
                .join('')}
            </tbody>
          </table>
        </div>
      `;
    }

    renderTableHeaderProduct(product) {
      const unitPriceText = this.getUnitPriceText(product);
      const profile = product.compare && product.compare.profile ? product.compare.profile : product.category_label;

      return `
        <div class="antifouling-compare__table-product">
          <div class="antifouling-compare__table-product-media">
            ${product.featured_image ? `<img src="${this.escapeAttribute(product.featured_image)}" alt="${this.escapeAttribute(product.title)}" loading="lazy">` : ''}
          </div>
          <div class="antifouling-compare__table-product-title">${this.escapeHtml(product.title)}</div>
          <div class="antifouling-compare__table-product-price">
            <strong>${this.escapeHtml(product.price_varies ? `${this.copy.from} ${product.price_from}` : product.price_from)}</strong>
            ${unitPriceText ? `<span class="antifouling-compare__table-muted">${this.escapeHtml(unitPriceText)}</span>` : ''}
            ${profile ? `<span class="antifouling-compare__table-muted">${this.escapeHtml(profile)}</span>` : ''}
          </div>
          <a class="antifouling-compare__product-link" href="${this.escapeAttribute(product.url)}">${this.escapeHtml(this.copy.open)}</a>
        </div>
      `;
    }

    getRowValue(key, product) {
      switch (key) {
        case 'profile':
          return product.compare && product.compare.profile ? product.compare.profile : product.type_text || product.category_label;
        case 'ideal_for':
          return product.compare ? product.compare.ideal_for : '';
        case 'application':
          return product.compare ? product.compare.application : '';
        case 'materials':
          return product.compare ? product.compare.materials : '';
        case 'waters':
          return product.compare ? product.compare.waters : '';
        case 'speed':
          return product.compare ? product.compare.speed : '';
        case 'system':
          return product.compare ? product.compare.system : product.type_text;
        case 'coverage':
          return product.compare ? product.compare.coverage : '';
        case 'coats':
          return product.compare ? product.compare.coats : '';
        case 'availability':
          return product.available ? this.copy.available : this.copy.unavailable;
        case 'sizes':
          return this.getSizeValue(product);
        case 'colors':
          return this.getColorItems(product);
        case 'environment':
          return product.compare ? product.compare.environment : '';
        case 'strengths':
          return this.getHighlights(product);
        case 'notes':
          return product.compare ? product.compare.notes : '';
        case 'documents':
          return product.documents || {};
        default:
          return '';
      }
    }

    renderRowValue(key, value) {
      if (!this.valueHasContent(value)) {
        return '<div class="antifouling-compare__table-content"><span class="antifouling-compare__table-muted">—</span></div>';
      }

      if (key === 'colors') {
        const labels = Array.isArray(value) ? value.map((color) => this.getColorLabel(color)).filter(Boolean) : [];
        return `
          <div class="antifouling-compare__table-content">
            <div class="antifouling-compare__swatches">${value.map((color) => this.renderSwatch(color)).join('')}</div>
            <span>${this.escapeHtml(labels.join(', '))}</span>
          </div>
        `;
      }

      if (key === 'sizes') {
        const sizeText = Array.isArray(value) ? value.join(', ') : value;
        return `<div class="antifouling-compare__table-content"><span>${this.escapeHtml(sizeText)}</span></div>`;
      }

      if (key === 'strengths') {
        return `<div class="antifouling-compare__table-content">${this.renderHighlights(value)}</div>`;
      }

      if (key === 'documents') {
        const links = [];

        if (value.tds) {
          links.push(`<a class="antifouling-compare__document" href="${this.escapeAttribute(value.tds)}" target="_blank" rel="noopener">${this.escapeHtml(this.copy.tds)}</a>`);
        }

        if (value.sds) {
          links.push(`<a class="antifouling-compare__document" href="${this.escapeAttribute(value.sds)}" target="_blank" rel="noopener">${this.escapeHtml(this.copy.sds)}</a>`);
        }

        return links.length
          ? `<div class="antifouling-compare__document-list">${links.join('')}</div>`
          : '<div class="antifouling-compare__table-content"><span class="antifouling-compare__table-muted">—</span></div>';
      }

      return `<div class="antifouling-compare__table-content"><span>${this.escapeHtml(String(value))}</span></div>`;
    }

    getHighlights(product) {
      const items = this.extractListItems(product.usp_html);

      if (items.length) {
        return items;
      }

      if (product.compare && product.compare.special) {
        return [product.compare.special];
      }

      if (product.description_excerpt) {
        return [product.description_excerpt];
      }

      return [];
    }

    extractListItems(html) {
      if (!html) {
        return [];
      }

      const wrapper = document.createElement('div');
      wrapper.innerHTML = html;

      const listItems = Array.from(wrapper.querySelectorAll('li'))
        .map((item) => item.textContent.trim())
        .filter(Boolean);

      if (listItems.length) {
        return listItems;
      }

      const text = wrapper.textContent.replace(/\s+/g, ' ').trim();

      return text ? [text] : [];
    }

    renderHighlights(items) {
      if (!items.length) {
        return '<span class="antifouling-compare__table-muted">—</span>';
      }

      return `<ul>${items.map((item) => `<li>${this.escapeHtml(item)}</li>`).join('')}</ul>`;
    }

    getUnitPriceText(product) {
      if (!Array.isArray(product.variants) || !product.variants.length) {
        return '';
      }

      let bestVariant = null;

      product.variants.forEach((variant) => {
        if (!variant || !variant.available || typeof variant.unit_price !== 'number' || variant.unit_price <= 0) {
          return;
        }

        if (!bestVariant || variant.unit_price < bestVariant.unit_price) {
          bestVariant = variant;
        }
      });

      if (!bestVariant) {
        return '';
      }

      const referenceValue = bestVariant.reference_value && Number(bestVariant.reference_value) !== 1 ? `${bestVariant.reference_value} ` : '';
      const referenceUnit = bestVariant.reference_unit || '';

      return `${this.copy.fromLower} ${this.formatMoney(bestVariant.unit_price)} / ${referenceValue}${referenceUnit}`.trim();
    }

    getSizeValue(product) {
      if (Array.isArray(product.sizes) && product.sizes.length) {
        return product.sizes.map((size) => this.normalizeSizeLabel(size)).filter(Boolean);
      }

      return product.compare && product.compare.amounts ? this.normalizeSizeLabel(product.compare.amounts) : [];
    }

    normalizeSizeLabel(value) {
      const label = String(value || '').trim();

      if (!label || label.toLowerCase() === 'default title') {
        return '';
      }

      return label
        .replace(/(\d)\s*(ml|kg|g|l)\b/gi, '$1 $2')
        .replace(/\s+/g, ' ')
        .trim();
    }

    getColorItems(product) {
      if (Array.isArray(product.color_swatches) && product.color_swatches.length) {
        return product.color_swatches;
      }

      if (Array.isArray(product.colors)) {
        return product.colors.map((color) => ({ label: color, color: null }));
      }

      return [];
    }

    getColorLabel(colorValue) {
      if (!colorValue) {
        return '';
      }

      if (typeof colorValue === 'string') {
        return colorValue;
      }

      return colorValue.label || colorValue.color || '';
    }

    getColorLabels(product) {
      return this.getColorItems(product).map((color) => this.getColorLabel(color)).filter(Boolean);
    }

    renderSwatch(colorValue) {
      const label = this.getColorLabel(colorValue);
      const explicitColor = colorValue && typeof colorValue === 'object' ? colorValue.color : '';
      const normalized = this.normalizeColorKey(label);
      const mappedColor = explicitColor || COLOR_MAP[normalized];
      let style = '';

      if (mappedColor) {
        style = mappedColor.startsWith('linear-gradient')
          ? `background-image:${mappedColor};`
          : `background-color:${mappedColor};`;
      }

      return `<span class="antifouling-compare__swatch" title="${this.escapeAttribute(label)}" aria-label="${this.escapeAttribute(label)}" style="${style}"></span>`;
    }

    normalizeColorKey(label) {
      return String(label || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[\/\s-]+/g, '_')
        .replace(/[^a-z0-9_]+/g, '')
        .replace(/^_+|_+$/g, '');
    }

    valueHasContent(value) {
      if (Array.isArray(value)) {
        return value.length > 0;
      }

      if (value && typeof value === 'object') {
        return Object.values(value).some((entry) => Boolean(entry));
      }

      return typeof value === 'string' ? value.trim().length > 0 : Boolean(value);
    }

    showNotice(message) {
      if (!this.noticeElement) {
        return;
      }

      this.noticeElement.textContent = message;
      this.noticeElement.hidden = false;

      if (this.noticeTimer) {
        clearTimeout(this.noticeTimer);
      }

      this.noticeTimer = window.setTimeout(() => {
        this.noticeElement.hidden = true;
      }, 3200);
    }

    interpolate(template, values) {
      return Object.keys(values).reduce(
        (result, key) => result.replaceAll(`{${key}}`, String(values[key])),
        String(template)
      );
    }

    formatMoney(cents) {
      try {
        return new Intl.NumberFormat(this.locale, {
          style: 'currency',
          currency: this.currency
        }).format(Number(cents) / 100);
      } catch (error) {
        return `${(Number(cents) / 100).toFixed(2)} ${this.currency}`;
      }
    }

    escapeHtml(value) {
      return String(value == null ? '' : value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    escapeAttribute(value) {
      return this.escapeHtml(value).replace(/`/g, '&#96;');
    }
  }

  if (!customElements.get('antifouling-comparison')) {
    customElements.define('antifouling-comparison', AntifoulingComparison);
  }
})();
